<div class="site-advert">
  <div class="image">
    <div *ngIf="site && site.logoTitle && !site.logoURL">
      <img [src]="'/assets/img/logos/sites/icons/'+site.logoTitle+'.png'" />
    </div>
    <div *ngIf="site && site.logoURL">
      <img [src]="site.logoURL"/>
    </div>
  </div>
  <div class="text">
    <div class="app-html-block" *ngIf="site.featuresHTML" [innerHtml]="site.featuresHTML"></div>
    <app-html-block *ngIf="!site.featuresHTML" [blockArray]="site.featuresContent"></app-html-block>
    <a [routerLink]="site.seoSlug">
      <button type='button' class="regular button solid-green {{site.seoSlug}}-learn-more">
      Learn More <span class="icon">&#xf3d1;</span>
      </button>
    </a>
  </div>
</div>
<hr/>
